// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.garp', {
    url: '/garp',
    templateUrl: 'main/configuration/garp/garp.tpl.html',
    data: { pageTitle: 'Garp' },
  });
};

angular.module('configuration.garp', []).config(config);
